import Icon from '../components/Icon.vue'

Icon.register({
  'chart-line': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 384c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-464c-17.7 0-32-14.3-32-32v-336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v304h432zM464 96c8.8 0 16 7.2 16 16v118c0 21.4-25.9 32.1-41 17l-32.4-32.4-96 96c-12.5 12.5-32.8 12.5-45.3 0l-73.4-73.4-46.1 46.1c-6.3 6.3-16.4 6.3-22.6 0l-22.6-22.6c-6.3-6.3-6.3-16.4 0-22.6l68.7-68.7c12.5-12.5 32.8-12.5 45.3 0l73.4 73.4 73.4-73.4-32.4-32.4c-15.1-15.1-4.4-41 17-41h118.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chart-line.js
// module id = 1173
// module chunks = 0